import { FC } from "react";

const FullPageLoader: FC = () => {
  return <div className="full-page-loader">...loading</div>;
};

export default FullPageLoader;
